"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _coreMixins = require("@vfuk/core-mixins");

var slideFromRight = {
  animation: (0, _coreMixins.createMixin)(function () {
    return (0, _styledComponents.css)(["@keyframes slideFromRight{0%{transform:translateX(100%);}100%{transform:translateX(0);}}"]);
  }),
  config: {
    duration: 150
  }
};
var _default = slideFromRight;
exports["default"] = _default;
//# sourceMappingURL=slideFromRight.js.map